import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HorizontalStackedBarChartComponent } from '@app/shared/components/charts/horizontal-bar-chart/horizontal-stacked-bar-chart.component';
import { DirectivesModule } from '@app/shared/directives/directives.module';
import { PipesModule } from '@app/shared/pipes/pipes.module';
import { TranslateModule } from '@ngx-translate/core';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { PcsComponentLibraryModule } from 'pcs-component-library';

import { BarLabelIconsWrapperComponent } from './components/bar-label-icons-wrapper/bar-label-icons-wrapper.component';
import { DoughnutChartComponent } from './doughnut-chart/doughnut-chart.component';

@NgModule({
  declarations: [
    HorizontalStackedBarChartComponent,
    DoughnutChartComponent,
    BarLabelIconsWrapperComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    PcsComponentLibraryModule,
    NgxChartsModule,
    PipesModule,
    DirectivesModule
  ],
  providers: [],
  exports: [
    HorizontalStackedBarChartComponent,
    DoughnutChartComponent
  ]
})
export class ChartsModule {
}
